
  import { DisputeTab } from "../dispute/disputeTabs";
  import { useState } from "react";
import { useOutletContext } from "react-router-dom";
  
  
  
  const Fraud = () => {
    const { setOpenDialog, openDialog } = useOutletContext();
  
    const [name, setName] = useState("fraud");
    const [activeTab, setActiveTab] = useState('fraud_rules');
    return (
      <>
      <DisputeTab
        name={name}
        setName={setName}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        >
          
        </DisputeTab>
        </>
    );
  };
  
  export default Fraud;